<template>
  <div class="homapt-expandable card" v-on:click="toURL(data._id)">
    <span v-if="data._source.special_cirumstances !== 'Off Market'">
      <img class="house-logo" src="../../../../../static/brokerlogo.jpg">
      <p class="broker d-inline">Brokered By: {{ data._source.brokerage }}</p>
    </span>
    <div class="image-card-wrapper">
      <img v-bind:class="{ 'card-img-top': !suggestedHouses, 'center-image': suggestedHouses }" v-bind:src="coverPhoto" alt="Home Cover Photo">
      <house-tag v-bind:house="data._source"></house-tag>
      <!--<save-button class="save-button" v-bind:houseId="data._id" v-on:save-home-user-not-logged-in="$emit('login-required')"></save-button>-->
    </div>
    <div class="card-footer">
        <div class="container-fluid">
          <div class="row margin-bottom">
            <div class="col my-auto">
              <h4 class="no-margin">{{price}}</h4>
            </div>
          </div>
          <div class="row">
            <div class="col my-auto">
              <p class="no-margin">{{data._source.bedroom_count}} Bed</p>
            </div>
            <div class="col my-auto">
              <p class="no-margin">{{data._source.bathroom_count}} Bath</p>
            </div>
            <div class="col my-auto">
              <p class="no-margin">{{sqft}} ft<sup>2</sup></p>
            </div>
          </div>
          <div class="row margin-bottom">
            <div class="col">
              <p class="no-margin address" v-line-clamp:20="1">{{ address }}</p>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import S3 from 'aws-sdk/clients/s3'
import HouseTag from '../../HouseTag.vue'
import SaveButton from '../../../general/buttons/SaveHomeButton.vue'
import router from '../../../../router/index.js'

export default {
  components: {
    HouseTag,
    SaveButton
  },
  props: {
    data: Object,
    searchString: {
      type: String,
      default: 'mn'
    },
    suggestedHouses: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      daysOfTheWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    }
  },
  computed: {
    address () {
      var addr = ''
      if (this.data._source.unit_number) addr = addr + this.data._source.unit_number + ' '
      if (this.data._source.street_number) addr = addr + this.data._source.street_number + ' '
      if (this.data._source.street_name) addr = addr + this.data._source.street_name + ' '
      if (this.data._source.street_suffix) addr = addr + this.data._source.street_suffix + ' '
      if (this.data._source.city) addr = addr + this.data._source.city + ' '
      if (this.data._source.state) addr = addr + this.data._source.state
      return addr
    },
    price () {
      if (!this.data._source.price) return ''
      return '$' + this.data._source.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    sqft () {
      if (!this.data._source.house_sqft) return ''
      return this.data._source.house_sqft.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    coverPhoto () {
      if (!this.data._source.photos) return ''
      var s3 = new S3()
      var photoArray = this.data._source.photos[0].split('/')
      photoArray.shift()
      var photoKey = 'medium/' + photoArray.join('/')
      var params = {
        Bucket: window.CONFIG.MLSPhotoBucketName,
        Key: photoKey
      }
      return s3.getSignedUrl('getObject', params)
    }
  },
  methods: {
    toURL (houseId) {
      router.push('/propertysearch/' + houseId + '/' + this.searchString + '/info')
    }
  }
}
</script>

<style scoped>
.center-image {
  height: 300px;
  width: 100%;
  object-fit: cover;
}

.address {
  font-size: 16px !important;
}

.margin-bottom {
  margin-bottom: .5rem;
}

.col {
  padding-left: 0;
  padding-right: 0;
}
.no-margin {
  margin: 0 !important;
}

.image-card-wrapper {
  position: relative;
}

.house-logo {
  padding: 0px;
  width: 20px;
  margin-left: .5rem;
}

.broker {
  margin-bottom: 0;
  font-size: 13px;
}

.card {
  border-radius: 10px;
  margin: .7rem;
  margin-top: 0;
  padding: .5rem;
  padding-top: 0 !important;
  cursor: pointer;
}

.learn-more-button {
  margin-top: 0px !important;
}

.save-button {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeSearch/rightSide/HomeCard.vue